import { HrCommonAuthority } from './hr-common-authority';
import { PersonnelAuthority } from './personnel-authority';
import { PersonnelReadableAuthority } from './personnel-readable-authority';
import { PersonnelDefinitionAuthority } from './personnel-definition-authority';
import { OrganizationAuthority } from './organization-authority';
import { OrganizationReadableAuthority } from './organization-readable-authority';
import { CadreAuthority } from './cadre-authority';
import { GeneralAuthority } from './general-authority';
import { PayrollDefinitionAuthority } from './payroll-definition-authority';
import { PayrollAuthority } from './payroll-authority';
import { TimeManagementAuthority } from './time-management-authority';
import { ApplicationAuthority } from './application-authority';
import { RecruitmentAuthority } from './recruitment-authority';
import { PerformanceAuthority } from './performance-authority';
import { EducationAuthority } from './education-authority';
import { AssignmentAuthority } from './assignment-authority';

export const HrAuthority = {
    All: new HrCommonAuthority(''),

    General: {
        All: new GeneralAuthority(''),
        CodeText: new GeneralAuthority('definition:code-text'),
        LegalRegulations: new GeneralAuthority('definition:legal-regulations'),
        ObjectConnection: new GeneralAuthority('definition:object-connection'),
        HrmDetail: new GeneralAuthority('definition:hrm-detail'),
        HrmDetailType: new GeneralAuthority('definition:hrm-detail-type'),
        EmployeeSubtype: new GeneralAuthority('definition:employee-subtype'),
        WorkSubarea: new GeneralAuthority('definition:work-subarea'),
        IdentificationSubtype: new GeneralAuthority('definition:identification-subtype'),
        PersonnelCardsCustomization: new GeneralAuthority('definition:personnel-cards'),
        SpecialSituationAllowance: new GeneralAuthority('definition:special-situation-allowance'),
        HrAuthorization: new GeneralAuthority('definition:hr-authorization'),
        ExamIntegrationCode: new GeneralAuthority('definition:exam-integration-code'),
        UniFacultyIntegration: new GeneralAuthority('definition:uni-faculty-integration'),
        TypeEduSubtype: new GeneralAuthority('definition:type-edu-subtype'),
        InstFacultyBranch: new GeneralAuthority('definition:inst-faculty-branch'),
        EduInstFaculty: new GeneralAuthority('definition:edu-inst-faculty'),
        SubtypeSchool: new GeneralAuthority('definition:subtype-school'),
    },

    Personnel: {
        All: new PersonnelAuthority(''),
        Admin: new PersonnelAuthority('admin'),
        Approve: new PersonnelAuthority('approve'),
        MasterApprove: new PersonnelAuthority('master:approve'),
        AdminPanel: new PersonnelAuthority('admin-panel'),
        Create: new PersonnelAuthority('create'),
        DegreeAdvancement: new PersonnelAuthority('degree-advancement'),
        DegreeAdvancementApprove: new PersonnelAuthority('degree-advancement-approve'),
        HistoricalDataBatchImport: new PersonnelAuthority('historical-data-batch'),
        Hitap: new PersonnelAuthority('hitap'),
        Profile: new PersonnelAuthority('profile'),
        ManagerDashboard: new PersonnelAuthority('manager-dashboard'),
        ManagerPanel: new PersonnelReadableAuthority('management'),
        CommonApprove: new PersonnelAuthority('common-approve'),
        LeaveRequestApprove: new PersonnelAuthority('leave-request-approve'),
        ExternalApplication: new PersonnelAuthority('external-application'),
        ForeignLanguageIntegration: new PersonnelAuthority('foreign-language-integration'),
        Termination: new PersonnelAuthority('termination'),
        TerminationEdit: new PersonnelAuthority('termination:modify'),
        DeclarationGoodsDraft: new PersonnelAuthority('declaration-goods:draft'),
        IntegrationAuth: new PersonnelAuthority('integration-auth'),
        LeaveRequest: {
            ALL: new PersonnelAuthority('leave-request'),
            EDIT: new PersonnelAuthority('leave-request:edit'),
            Approve: new PersonnelAuthority('leave-request:approve'),
            Manage: new PersonnelAuthority('leave-request:manage'),
            PkoPuantor: new PersonnelAuthority('leave-request:pko-puantor'),
        },
        MassTermination: new PersonnelAuthority('mass-termination'),
        Import: new PersonnelAuthority('import'),
        QueryBuilder: new PersonnelAuthority('org-query-builder'),
        PerPhotoImport: new PersonnelAuthority('photo-import'),
        PassportDemandEdit: new PersonnelDefinitionAuthority('passport-demand:edit'),
        WorkCertificateDemandEdit: new PersonnelDefinitionAuthority('work-certificate-demand:edit'),
        MovementRequestPeriodEdit: new PersonnelDefinitionAuthority('movement-request-period:edit'),
        MovementRequestRuleEdit: new PersonnelDefinitionAuthority('movement-request-rule:edit'),
        MovementRequestAdminEdit: new PersonnelDefinitionAuthority('movement-request-admin:edit'),
        MovementRequestEdit: new PersonnelDefinitionAuthority('movement-request:edit'),
        Definitions: {
            All: new PersonnelDefinitionAuthority(''),
            CodeText: new PersonnelDefinitionAuthority('code-text'),
            MonthlyIndicator: new PersonnelDefinitionAuthority('monthly-indicator'),
            DegreeEducationLevel: new PersonnelDefinitionAuthority('degree-education-level'),
            AdditionalIndicator: new PersonnelDefinitionAuthority('additional-indicator'),
            KindKindTypeRel: new PersonnelDefinitionAuthority('kind-type'),
            VehicleMakeRel: new PersonnelDefinitionAuthority('vehicle-make-rel'),
            Task: new PersonnelDefinitionAuthority('task'),
            TaskGroup: new PersonnelDefinitionAuthority('task-group'),
            SyndicateDefRel: new PersonnelDefinitionAuthority('syndicate-def-rel'),
            MovementReturnStatus: new PersonnelDefinitionAuthority('movement-return-status'),
            MovementServiceStatus: new PersonnelDefinitionAuthority('movement-service-status'),
            StMandatoryField: new PersonnelDefinitionAuthority('st-mandatory-field'),
            StatusMovementTypeRel: new PersonnelDefinitionAuthority('status-movement-type-rel'),
            OrgStatusActivityRel: new PersonnelDefinitionAuthority('org-status-activity-association'),
            AdvancementAbsenceTypeConf: new PersonnelDefinitionAuthority('advancement-absence-type-conf'),
        },
        Reports: {
            Reports: new PersonnelDefinitionAuthority('reports'),
            EmptyCadreReport: new PersonnelDefinitionAuthority('reports:empty_cadre_report'),
            CadreRegisterReport: new PersonnelDefinitionAuthority('reports:cadre_register_report'),
        },
        SelectOrg: new PersonnelAuthority('select-org'),
        SecretOrg: new PersonnelAuthority('secret-org'),
    },

    Organization: {
        All: new OrganizationAuthority(''),
        Organization: new OrganizationAuthority('organization'),
        OrganizationTree: new OrganizationReadableAuthority('organization:tree'),
        OrganizationSchema: new OrganizationReadableAuthority('organization:schema'),
        Position: new OrganizationReadableAuthority('position'),
        Title: new OrganizationReadableAuthority('title'),
        Commission: new OrganizationAuthority('commission'),
        CommissionApprove: new PersonnelAuthority('commission-approve'),
        OrganizationType: new OrganizationAuthority('type'),
        Template: new OrganizationAuthority('template'),
        Version: new OrganizationAuthority('version'),
        Cadre: {
            All: new CadreAuthority(''),
            Definition: new CadreAuthority('definition'),
            EmptyStaff: new CadreAuthority('empty-staff'),
            FullStaff: new CadreAuthority('full-staff'),
        },
    },

    Payroll: {
        ALL: new PayrollAuthority(''),
        EngineLog: new PayrollAuthority('engine-log'),
        Ongoing: new PayrollAuthority('ongoing'),
        PayrollReport: new PayrollAuthority('payroll-report'),
        Process: new PayrollAuthority('process'),
        SummaryReport: new PayrollAuthority('summary-report'),
        WageTypeReport: new PayrollAuthority('wage-type-report'),
        FeeTypeReport: new PayrollAuthority('fee-type-report'),
        InsTypeWageTypeRel: new PayrollAuthority('ins-type-wage-type-rel'),
        PersonnelMasterData: {
            ALL: new PayrollAuthority('personnel-master-data'),
            PayrollInfo: new PayrollAuthority('personnel-master-data:payroll-info'),
            Alimony: new PayrollAuthority('personnel-master-data:alimony'),
            AdvanceDeduction: new PayrollAuthority('personnel-master-data:advance-deduction'),
            Execution: new PayrollAuthority('personnel-master-data:execution'),
            SI_DEDUCTION: new PayrollAuthority('personnel-master-data:personnel-s-i-deduction-law'),
            RND: new PayrollAuthority('personnel-master-data:per-payroll-r-n-d'),
            PayrollState: new PayrollAuthority('personnel-master-data:per-payroll-state'),
            PerInsPolicyInfo: new PayrollAuthority('personnel-master-data:per-payroll-state'),
            PaySeveranceNoticeAnnualLeave: new PayrollAuthority(
                'personnel-master-data:pay-severance-notice-annual-leave',
            ),
            PayrollRecords: new PayrollAuthority('personnel-master-data:payroll-records'),
            AdditionalPayment: new PayrollAuthority('personnel-master-data:additional-payment'),
            CommonPayment: new PayrollAuthority('personnel-master-data:common-payment'),
            Deduction: new PayrollAuthority('personnel-master-data:deduction'),
            IndividualPayment: new PayrollAuthority('personnel-master-data:individual-payment'),
            PerSsiOffSetting: new PayrollAuthority('personnel-master-data:per-ssi-off-setting'),
        },

        Definitions: {
            ALL: new PayrollDefinitionAuthority(''),
            AdditionalPayRate: new PayrollDefinitionAuthority('additional-pay-rate'),
            AdminDutyAllowanceRate: new PayrollDefinitionAuthority('admin-duty-allowance-rate'),
            CodeText: new PayrollDefinitionAuthority('code-text'),
            CompensationsAllowances: new PayrollDefinitionAuthority('compensations-allowances'),
            ConstantAmount: new PayrollDefinitionAuthority('constant-amount'),
            ConstantNumber: new PayrollDefinitionAuthority('constant-number'),
            ConstantPublic: new PayrollDefinitionAuthority('constant-public'),
            DevelopmentAllowanceRate: new PayrollDefinitionAuthority('development-allowance-rate'),
            ForeignLangCompIndicator: new PayrollDefinitionAuthority('foreign-lang-comp-indicator'),
            FringePayPoint: new PayrollDefinitionAuthority('fringe-pay-point'),
            GroupEmployeeSubtype: new PayrollDefinitionAuthority('group-employee-subtype'),
            GroupWorkInfo: new PayrollDefinitionAuthority('group-work-info'),
            GroupWorkSubarea: new PayrollDefinitionAuthority('group-work-subarea'),
            HigherEduCompensationRate: new PayrollDefinitionAuthority('higher-edu-compensation-rate'),
            IncomeTaxBracket: new PayrollDefinitionAuthority('income-tax-bracket'),
            Increment: new PayrollDefinitionAuthority('increment'),
            MinLivAllowanceAmount: new PayrollDefinitionAuthority('min-liv-allowance-amount'),
            PayrollKindManner: new PayrollDefinitionAuthority('payroll-kind-manner'),
            PayrollName: new PayrollDefinitionAuthority('payroll-name'),
            PayrollSwitch: new PayrollDefinitionAuthority('payroll-switch'),
            PayrollSwitchRelation: new PayrollDefinitionAuthority('payroll-switch-relation'),
            PayrollSwitchOffsetDate: new PayrollDefinitionAuthority('payroll-switch-offset-date'),
            ExpenseTypeWageTypeRelation: new PayrollDefinitionAuthority('expense-type-wage-type-relation'),
            TravelWageTypeRelation: new PayrollDefinitionAuthority('travel-wage-type-relation'),
            PayrollTypeManner: new PayrollDefinitionAuthority('payroll-type-manner'),
            PeriodDate: new PayrollDefinitionAuthority('period-date'),
            PosDutyReprCompIndicator: new PayrollDefinitionAuthority('pos-duty-repr-comp-indicator'),
            RegionRegionTypeRelation: new PayrollDefinitionAuthority('region-region-type-relation'),
            RegionSubProvinceMatch: new PayrollDefinitionAuthority('region-subprovince-match'),
            RetirementDeductionRate: new PayrollDefinitionAuthority('retirement-deduction-rate'),
            RndIncomeTaxDeduction: new PayrollDefinitionAuthority('rnd-income-tax-deduction'),
            RndProject: new PayrollDefinitionAuthority('rnd-project'),
            Script: new PayrollDefinitionAuthority('script'),
            SiDeductionLawRate: new PayrollDefinitionAuthority('si-deduction-law-rate'),
            SpecialServiceCompRate: new PayrollDefinitionAuthority('special-service-comp-rate'),
            SstInfo: new PayrollDefinitionAuthority('sst-info'),
            SstPercentage: new PayrollDefinitionAuthority('sst-percentage'),
            StampTaxArea: new PayrollDefinitionAuthority('stamp-tax-area'),
            SummaryReport: new PayrollDefinitionAuthority('summary-report'),
            InsTypeWageTypeRel: new PayrollDefinitionAuthority('ins-type-wage-type-rel'),
            SwitchState: new PayrollDefinitionAuthority('switch-state'),
            TaxManagement: new PayrollDefinitionAuthority('tax-management'),
            TravelExpenseDeductionAmount: new PayrollDefinitionAuthority('travel-expense-deduction-amount'),
            UniversityAllowanceRate: new PayrollDefinitionAuthority('university-allowance-rate'),
            WageScaleValuation: new PayrollDefinitionAuthority('wage-scale-valuation'),
            BatchCompensationCalculation: new PayrollDefinitionAuthority('batch-compensation-calculation'),
            WageType: new PayrollDefinitionAuthority('wage-type'),
            WtCumulative: new PayrollDefinitionAuthority('wt-cumulative'),
        },
    },

    TimeManagement: {
        ALL: new TimeManagementAuthority(''),
        AbsenceQuota: new TimeManagementAuthority('absence-quota'),
        AbsenceWageType: new TimeManagementAuthority('absence-wage-type'),
        DiscountRule: new TimeManagementAuthority('discount-rule'),
        EffortEntry: new TimeManagementAuthority('effort-entry'),
        EffortEntryAdmin: new TimeManagementAuthority('effort-entry-admin'),
        Engine: {
            ALL: new TimeManagementAuthority('engine'),
            EngineIntTab: new TimeManagementAuthority('engine:int-tab'),
            EngineParameter: new TimeManagementAuthority('engine:parameter'),
            EngineReport: new TimeManagementAuthority('engine:report'),
            EngineRun: new TimeManagementAuthority('engine:run'),
            EngineScript: new TimeManagementAuthority('engine:script'),
        },
        FlexibleWorkingReport: new TimeManagementAuthority('flexible-working-report:edit'),
        LeaveRequestScreenRule: new TimeManagementAuthority('leave-request-screen-rule'),
        Premiums: new TimeManagementAuthority('premiums'),
        Turnstile: new TimeManagementAuthority('turnstile'),
        WorkProgram: new TimeManagementAuthority('work-program'),
        RdReport: new TimeManagementAuthority('rdReport'),
        OutOfWorkPersonnelReport: new TimeManagementAuthority('outOfWorkPersonnelReport'),
        PersonnelMasterData: {
            ALL: new TimeManagementAuthority('personnel-master-data'),
            AbsenceEntry: new TimeManagementAuthority('personnel-master-data:absence-entry'),
            AbsenceQuota: new TimeManagementAuthority('personnel-master-data:absence-quota'),
            AttendenceMaster: new TimeManagementAuthority('personnel-master-data:attendence-master'),
            Overtime: new TimeManagementAuthority('personnel-master-data:overtime'),
            PayrollIntegration: new TimeManagementAuthority('personnel-master-data:payroll-integration'),
            WorkSchedule: new TimeManagementAuthority('personnel-master-data:work-schedule'),
            TmProjectInfo: new TimeManagementAuthority('personnel-master-data:tm-project-info'),
            FlexibleWorkingReport: new TimeManagementAuthority('personnel-master-data:flexible-working-report'),
        },
        QuotaInquiry: new TimeManagementAuthority('quota-inquiry'),
    },

    Application: {
        All: new ApplicationAuthority(''),
        Dashboard: new ApplicationAuthority('dashboard'),
        PreApplication: new ApplicationAuthority('pre-application'),
        DetailedApplication: new ApplicationAuthority('detailed-application'),
        INTERNAL_AUTHORITY: 'applicationInternalAuthority',
        ViewApplicantSalaryInfos: new ApplicationAuthority('view-applicant-salary-info'),
    },

    Recruitment: {
        All: new RecruitmentAuthority(''),
        AddApplicantCv: new RecruitmentAuthority('add-applicant-cv'),
        Announcement: {
            All: new RecruitmentAuthority('announcement'),
            Edit: new RecruitmentAuthority('announcement:edit'),
        },
        AnnouncementPosition: new RecruitmentAuthority('announcement-position'),
        AnnouncementTemplate: new RecruitmentAuthority('announcement-template'),
        Applications: new RecruitmentAuthority('applications'),
        Board: new RecruitmentAuthority('board'),
        BudgetPlanning: new RecruitmentAuthority('budget-planning'),
        BusinessFamilyLevelGrouping: new RecruitmentAuthority('business-family-level-grouping'),
        BusinessFamilyParameterRel: new RecruitmentAuthority('business-family-parameter-rel'),
        BusinessFamParameter: new RecruitmentAuthority('business-fam-parameter'),
        BusinessParameterRel: new RecruitmentAuthority('business-parameter-rel'),
        CodeText: new RecruitmentAuthority('code-text'),
        CollectivePolicyUpdate: new RecruitmentAuthority('collective-policy-update'),
        EducationParameter: new RecruitmentAuthority('education-parameter'),
        ExecutiveDashboard: new RecruitmentAuthority('executive-dashboard'),
        Form: new RecruitmentAuthority('form'),
        InApplication: new RecruitmentAuthority('in-application'),
        IndividualTransactions: new RecruitmentAuthority('individual-transactions'),
        LocationParameter: new RecruitmentAuthority('location-parameter'),
        MyRequirements: new RecruitmentAuthority('my-requirements'),
        PayManagement: new RecruitmentAuthority('pay-management'),
        PositionSoftSkill: new RecruitmentAuthority('position-soft-skill'),
        InternRequirement: {
            ALL: new RecruitmentAuthority('intern-requirement'),
            Self: new RecruitmentAuthority('intern-requirement:self'),
        },
        Process: {
            ALL: new RecruitmentAuthority('process'),
            JobOffer: new RecruitmentAuthority('process:job-offer'),
            ReferenceAnswer: new RecruitmentAuthority('process:reference-answer'),
            Guide: new RecruitmentAuthority('process:guide'),
            Board: new RecruitmentAuthority('process:hr-board'),
            Starting: new RecruitmentAuthority('process:starting'),
            Changing: new RecruitmentAuthority('process:changing'),
            TechnicalInterview: new RecruitmentAuthority('process:technical-interview'),
        },
        RelationParameter: new RecruitmentAuthority('relation-parameter'),
        RequirementAssessment: new RecruitmentAuthority('requirement-assessment'),
        RequirementAdmin: new RecruitmentAuthority('requirement-assessment-admin'),
        StartingAdmin: new RecruitmentAuthority('starting-admin'),
        ChangingAdmin: new RecruitmentAuthority('changing-admin'),

        iseAlimYetkilisiAuth: 'iseAlimYetkilisiAuth',
        isTeklifYetkilisiAuth: 'isTeklifYetkilisiAuth',
        ucretCalismasiOnayRole: 'ucretCalismasiOnayRole',
        isTeklifBpmnRole: 'isTeklifBpmnRole',
        isTeklifYetkilisiMenuRole: 'isTeklifYetkilisiMenuRole',
        ucretCalismasiOnayRoleAuth: 'ucretCalismasiOnayRoleAuth',
        ucretCalismasiYetkilisiRole: 'ucretCalismasiYetkilisiRole',
        ucretCalismasiYetkilisiAuth: 'ucretCalismasiYetkilisiAuth',
        ustYoneticiIKAuthority: 'ustYoneticiIKAuthority',
        genelMudurAuthority: 'genelMudurAuthority',
        ustYoneticiAuthority: 'ustYoneticiAuthority',
        recruitmentShowAllOrganizationData: 'recruitmentShowAllOrganizationData',
    },

    Performance: {
        All: new PerformanceAuthority(''),
        ManagerAuthority: new PerformanceAuthority('objective-prf-period'),
        Objective: new PerformanceAuthority('objective'),
    },

    Education: {
        CourseEvaluation: new EducationAuthority('course-evaluation:edit'), //kovan:hr:education:course-evaluation
        CourseEvaluationResults: new EducationAuthority('course-evaluation-results:edit'), //kovan:hr:education:course-evaluation-results
    },

    Assignment: {
        All: new AssignmentAuthority(''),
    },
};

export function combineAuth(...authorityList): string {
    let result = '';
    authorityList.forEach((authority) => {
        if (!authority) return;
        result += result ? ':' + authority : authority;
    });
    return result;
}
